/* eslint-disable no-console */
import Horn from '@utils/horn';
import { reportCustomMetrics, CUSTOM_METRICS } from '@utils/owlReporter';
import * as Ids from '@utils/ids';
import { isHitGray, ICommoneHornGrayConfig } from '@utils/commonHornGrayUtils';

/**
 * 长任务配置项接口
 */
interface ILongTaskConfig {
    /** 长任务阈值 */
    threshold: number;
    /** 灰度配置 */
    gray: ICommoneHornGrayConfig;
}

const longTaskConfig = Horn.getConfigByFieldName<ILongTaskConfig>(
    Horn.CONFIG_FIELD.LONG_TASK_CONFIG,
);

/** 长任务阈值 */
const longTaskThreshold = (longTaskConfig && longTaskConfig.threshold) || 500;

/** 是否命中长任务灰度 */
const isHitLongTaskCanary = isHitGray((longTaskConfig && longTaskConfig.gray) || null);

/** iframe列表 */
const IFRAMES = {
    /**内层页面iframe名称 */
    HASH_FRAME: 'hashframe',
    /**智能客服iframe名称 */
    CS_FRAME: 'csChatIframe',
    /**IM iframe名称 */
    IM_FRAME: 'J-imframe',
};

/**
 * 获取长任务发生的页面链接
 * 1.当是内层页面时,获取外层页面的hash,
 * 2.当时智能客服时，直接获取智能客服页面链接
 * 3.当时im时,获取当前frame的href
 * 4.当外层页面时,获取外层页面的href
 */
const getIFrameUrl = function(iframeName: string): string {
    let iframeUrl = '';
    try {
        if (iframeName === IFRAMES.HASH_FRAME) {
            iframeUrl = window.location.hash;
        } else if (iframeName === IFRAMES.CS_FRAME) {
            iframeUrl = (window.frames as any).csChatIframe.src;
        } else if (iframeName === IFRAMES.IM_FRAME) {
            iframeUrl =
                (window.frames as any)[iframeName] &&
                (window.frames as any)[iframeName]?.location?.href;
        } else {
            iframeUrl = window.location.href;
        }
        return iframeUrl;
    } catch (error) {
        console.error('获取iframeUrl失败');
        return iframeUrl;
    }
};

/**
 * 运行时性能检测：长任务检测
 * 捕获某些浏览器在使用新的“type”选项时会引发错误。 https://bugs.webkit.org/show_bug.cgi?id=209216
 */
function observerLongTask() {
    try {
        if (window.PerformanceObserver && isHitLongTaskCanary) {
            new PerformanceObserver((list: any) => {
                const perfEntries: Array<any> = list.getEntries();
                for (let i = 0; i < perfEntries.length; i++) {
                    const { duration, name, attribution } = perfEntries[i];
                    if (duration > longTaskThreshold) {
                        let iframeName = 'shell';
                        if (
                            name !== 'self' &&
                            Array.isArray(attribution) &&
                            attribution.length > 0
                        ) {
                            iframeName = attribution[0].containerName;
                        }
                        reportCustomMetrics(
                            CUSTOM_METRICS.LONG_TASK.KEY,
                            duration,
                            {
                                [CUSTOM_METRICS.LONG_TASK.TAGS.IFRAME_NAME]: iframeName,
                            },
                            {
                                [CUSTOM_METRICS.LONG_TASK.EXTRA.ACCT_ID]: Ids.getAcctId(),
                                [CUSTOM_METRICS.LONG_TASK.EXTRA.IFRAME_URL]: getIFrameUrl(
                                    iframeName,
                                ),
                            },
                        );
                    }
                }
            }).observe({ entryTypes: ['longtask'] });
        }
    } catch (error) {
        console.error('该浏览器不支持PerformanceObserver longtask 条目');
    }
}

export default observerLongTask;
